import { Routes } from './Routes.js';
import './App.css';

function App() {
  return <Routes />;
}

export default App;
